import React, { useEffect, useState } from 'react'

import AuthAxios from '../../../utils/AuthAxios';
import Swal from 'sweetalert2';


function AfterSales(props) {

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {

    async function getData () {
      AuthAxios.get('/vorteilspartner/after-sales')
      .then(res => {
        setData(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: "Fehler",
          html: "After-Sales konnten nicht geladen werden."
        });
      });
    }

    if(props.tab == props.activeTab) {
      getData();
    }

  },[props.activeTab]);

  return (
    <div>AfterSales</div>
  )
}


export default AfterSales